import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ContentWrapper from "../content_wrapper/ContentWrapper";
import { Alert, Button, Descriptions, Empty, Icon, message, Popconfirm, Spin, Table } from 'antd';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import AnimateEnter from '../AnimateEnter';
import { CONTACTS_GROUPS_RESOURCE_NAME, CONTACTS_RESOURCE_NAME } from '../../config/constants';
import { _callResource } from '../../context/_callResource';
import { ApiError } from '../../utils/errors';
import { allContactsFromGroupColumns } from './columns/allContactsFromGroup';
import { grammarNumbers } from '../../Utils';
import TEXTS from "../../locale/texts";
import MESSAGES from "../../locale/messages";

class ContactGroupDetail extends Component {
  state = {
    isDeleteLoading: false,
    isMounted: false,

    // one of contacts groups resource
    oneOfContactsGroupsData: null,
    oneOfContactsGroupsDataIsLoading: true,
    oneOfContactsGroupsDataError: null,

    blacklistContactsIsLoading: false,
    blacklistContactsError: null,

    deleteOneOfContactsGroupsIsLoading: false,
    deleteOneOfContactsGroupsError: null,

    showContacts: false,

    contactsData: [],
    contactsDataIsLoading: false,
    contactsDataError: null,

    contactsMounted: true,

    currentPage: 1,
    pageSize: 10,
  };

  columns = allContactsFromGroupColumns.bind(this);
  callResource = _callResource.bind(this);

  componentDidMount = () => {
    window.scrollTo(0, 198);
    this.getContactGroupData();
  };

  onDelete = async () => {
    const { id } = this.state.oneOfContactsGroupsData;
    const { promiseCancelToken, addNotification, lang} = this.props;
    this.callResource({
      resourceName: CONTACTS_GROUPS_RESOURCE_NAME,
      apiClassName: 'contactsGroups',
      action: 'deleteOneOf',
      apiCallParams: { id },
      promiseCancelToken,
      onSuccess: () => {
        addNotification(TEXTS.groupIsDeleted[lang]);
        this.toAllContactGroups();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        message.error(`${TEXTS.couldNotDeleteOneGroup[lang]}: ${errorMessage}.`, 5);
      }
    });
  };

  onEdit = () => {
    const { id, history } = this.props;
    history.push({
      pathname: `/phonebook/groups/edit/${id}`,
      state: { ...this.state.oneOfContactsGroupsData }
    });
  };

  toAllContactGroups = () => {
    this.props.history.push('/phonebook/groups');
  };

  getContactGroupData = () => {
    const { id, promiseCancelToken } = this.props;
    this.callResource({
      resourceName: CONTACTS_GROUPS_RESOURCE_NAME,
      apiClassName: 'contactsGroups',
      action: 'getOneOf',
      apiCallParams: { id },
      promiseCancelToken
    });
  };

  getGroupContacts = () => {
    const { promiseCancelToken } = this.props;
    const { id } = this.state.oneOfContactsGroupsData;
    this.setState({
      showContacts: true,
      selectedRows: []
    });
    this.callResource({
      resourceName: CONTACTS_RESOURCE_NAME,
      apiClassName: 'contacts',
      action: 'get',
      apiCallParams: { groupId: id, inBlackList: false },
      promiseCancelToken,
      onSuccess: () => {
        this.setState({ showContacts: true });
      }
    });
  };

  renderContacts = () => {
    const {
      contactsData,
      contactsDataError,
      contactsMounted,
      pageSize,
      currentPage
    } = this.state;
    const {lang} = this.props;

    if (contactsDataError) {
      const { errorTitle, errorMessage } = contactsDataError;
      return (
        <Alert
          message={errorTitle}
          description={errorMessage}
          type="error"
        />
      );
    }

    const columns = this.columns(pageSize, currentPage, lang);

    return (
      <AnimateEnter
        paginationAnimate={{ isMounted: contactsMounted }}
      >
        <Table
          dataSource={contactsData ? contactsData.items : []}
          columns={columns}
          rowKey={({ id }) => id}
          pagination={{
            pageSize,
            hideOnSinglePage: true,
            size: 'large',
            onChange: (page) => {
              this.setState({
                currentPage: page,
                contactsMounted: false
              });
              setTimeout(() => {
                this.setState({ contactsMounted: true });
              }, 0);
            }
          }}
        />
      </AnimateEnter>
    );
  };

  renderData = () => {
    const { lang } = this.props;
    const {
      oneOfContactsGroupsData,
      isBlacklistLoading,
      isMounted,
      oneOfContactsGroupsDataError,
      deleteOneOfContactsGroupsIsLoading,
      showContacts,
      contactsDataIsLoading
    } = this.state;
    const colSpan = 2;

    if (oneOfContactsGroupsDataError) {
      const { errorTitle, errorMessage } = oneOfContactsGroupsDataError;
      return (
        <Alert
          message={errorTitle}
          description={errorMessage}
          type="error"
        />
      );
    }

    const {
      name,
      note,
      inBlackList,
      contactCount,
      blackContactCount
    } = oneOfContactsGroupsData;

    return (
      <AnimateEnter in={isMounted}>
        <div>
          <h4
            className="form-row title text-pink text-uppercase mb-4"
            style={{
              display: 'inline-block',
              marginRight: 10
            }}
          >
            {name}
          </h4>
          <Button
            type="primary"
            ghost
            icon="edit"
            shape="circle"
            title={TEXTS.btnEdit[lang]}
            style={{position: 'relative', top: -2, marginRight: 5}}
            onClick={this.onEdit}
          />
          <Popconfirm
            placement="right"
            title={TEXTS.areYouSureToDeleteContactGroup[lang]}
            okText={TEXTS.yes[lang]}
            cancelText={TEXTS.btnToCancel[lang]}
            onConfirm={this.onDelete}
          >
            <Button
              type="danger"
              ghost={!deleteOneOfContactsGroupsIsLoading}
              icon="delete"
              shape="circle"
              title={TEXTS.btnDelete[lang]}
              loading={deleteOneOfContactsGroupsIsLoading}
              style={{position: 'relative', top: -2}}
            />
          </Popconfirm>
        </div>
        <div className="mb-4">
          <Button
            className="mr-3"
            style={{padding: '0 20px 0 20px', height: 45, marginLeft: 0}}
            disabled={showContacts || contactsDataIsLoading}
            onClick={this.getGroupContacts}
          >
            {contactsDataIsLoading
              && <Icon type="loading" style={{position: 'relative', top: -3, fontSize: 18}} />}
            {!contactsDataIsLoading
              && <Icon type="ordered-list" style={{position: 'relative', top: -3, fontSize: 18}} />}
            {TEXTS.showAllGroupContacts[lang]}
          </Button>
        </div>
        <Descriptions
          column={{
            xxl: 2,
            xl: 2,
            lg: 2,
            md: 2,
            sm: 1,
            xs: 1
          }}
          size="middle"
          bordered
          style={{marginBottom: 50}}
        >
          <Descriptions.Item label={TEXTS.thGroupName[lang]} span={colSpan}>
            {name}
          </Descriptions.Item>
          <Descriptions.Item label={TEXTS.comment[lang]} span={colSpan}>
            {note}
          </Descriptions.Item>
          <Descriptions.Item label={TEXTS.thContactsCount[lang]} span={colSpan}>
            {contactCount}
          </Descriptions.Item>
          <Descriptions.Item label={TEXTS.thBlackListCount[lang]} span={colSpan}>
            {blackContactCount}
            {' '}
            {MESSAGES.contacts(blackContactCount)[lang]}
          </Descriptions.Item>
        </Descriptions>
        {showContacts && (contactsDataIsLoading
          ? <>
              <Empty description={TEXTS.dataIsLoading[lang]} />
              <div style={{marginTop: 15, textAlign: 'center'}}>
                <Spin spinning={true} />
              </div>
            </>
          : this.renderContacts())}
      </AnimateEnter>
    )
  };

  render() {
    const { lang } = this.props;
    return(
      <div>
        <ContentWrapper>
          {this.state.oneOfContactsGroupsDataIsLoading
            ? <>
                <Empty description={TEXTS.dataIsLoading[lang]} />
                <div style={{marginTop: 15, textAlign: 'center'}}>
                  <Spin spinning={true} />
                </div>
              </>
            : this.renderData()}
        </ContentWrapper>
      </div>
    );
  }
}

export default withRouter(ContactGroupDetail);
